import { NoteEventTime } from "@playground-sessions/pitch-detection/types/toMidi";

export function sortNotesByPitchThenByStartTime(notes: NoteEventTime[]): NoteEventTime[] {
  return notes.sort((a, b) => {
    if (a.pitchMidi === b.pitchMidi) {
      return a.startTimeSeconds - b.startTimeSeconds;
    } else {
      return a.pitchMidi - b.pitchMidi;
    }
  });
}

export function combineDuplicateNotes(notes: NoteEventTime[]): NoteEventTime[] {
  const result: NoteEventTime[] = [];
  let lastNote: NoteEventTime | null = null;

  const startTimeDifferenceThreshold = 0.2;

  for (const note of notes) {
    const isFirstNote = !lastNote;
    const didPitchChange = note.pitchMidi !== lastNote?.pitchMidi;
    const doesTimeDifferenceExceedThreshold = Math.abs(note.startTimeSeconds - (lastNote?.startTimeSeconds || 0)) > startTimeDifferenceThreshold;

    if (isFirstNote || didPitchChange || doesTimeDifferenceExceedThreshold) {
      result.push(note);
      lastNote = note;
    } else {
      // Found a duplicate. Change the durationSeconds value of the note already in the result array to include the
      // durationSeconds value of the duplicate note.
      const lastNoteIndex = result.length - 1;
      result[lastNoteIndex].durationSeconds += note.durationSeconds;
    }
  }

  return result;
}